<div style="width: 100%;">
  <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; margin-top: 10px" [formGroup]="quizForm">
    <div style="width: 100%">
      <mat-form-field style="width: 100%">
        <mat-label>Reference Name</mat-label>
        <input matInput type="url"  formControlName="name" name="name" style="width: 200px;" />
      </mat-form-field>
    </div>
    <div style="width: 100%">
      <mat-form-field style="width: 100%">
        <mat-label>URL</mat-label>
        <input matInput type="url"  formControlName="url" name="url" style="width: 200px;" />
      </mat-form-field>
    </div>
    <div style="width: 100%">
      <mat-form-field style="width: 100%">
        <mat-label>Source/Provider</mat-label>
        <input matInput type="url"  formControlName="sourceProvider" name="sourceProvider"
               style="width: 200px;" />
      </mat-form-field>
    </div>
  </div>

  <div *ngIf="entity.referenceResourceId">
    <div class="splitter">Control Items</div>
    <p-table
      [value]="entity.controlItemReferences"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Control ID</th>
          <th>Framework</th>
          <th style="width: 3em;"></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{item.controlId}}</td>
          <td>{{item.complianceAreaName}}</td>
          <td>
            <button
              type="button"
              pButton
              class="risksponge-button"
              (click)="removeReference(item)"
              icon="pi pi-trash">
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div>
      <button
        type="button"
        pButton
        class="risksponge-button"
        (click)="addReference()"
        icon="pi pi-plus">
      </button>
    </div>
  </div>

  <div style="display: flex; flex-direction: row; justify-content: center; align-items: center; margin-top: 10px">
    <button mat-raised-button (click)="generate()">Ok</button>
  </div>
</div>
